module.exports = __webpack_public_path__ + "static/media/aictia-logo.78e8ba5e.png";